import { AllCalendarEntry } from '../schema/AllCalendarEntry';

export const isCalendarEntryForReadOnlyCalendar = (calendarEntry: AllCalendarEntry) =>
    calendarEntry?.IsReadOnly;
